function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M50.4643 7.62421C51.6227 10.3334 52.4285 13.7223 51.9924 17.5938C51.8852 18.5587 52.0076 19.515 52.3496 20.4112M46.3207 1.2251C46.4233 1.30853 46.519 1.40097 46.6081 1.50131C47.2738 2.25543 47.962 3.15712 48.5993 4.13717M5.65625 20.3847C5.99071 19.498 6.10982 18.5475 6.0039 17.5938C5.19591 10.4123 8.6566 4.88802 10.7233 2.295C10.9679 1.98835 11.1921 1.72341 11.3882 1.50131C11.4772 1.40097 11.573 1.30853 11.6755 1.2251",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.03686 32.9109C4.61315 31.053 4.39453 29.0101 4.39453 26.7802C4.39453 24.5874 4.82275 22.4757 5.61383 20.4994C8.32964 18.3258 8.80744 16.0282 8.79843 14.6561C8.79504 13.9752 9.56359 13.5693 10.1225 13.9583C10.4223 14.1668 10.7029 14.4126 10.9519 14.6606C11.4601 15.1657 12.3346 14.8376 12.3853 14.1217C12.4439 13.2999 12.3763 12.5501 12.285 11.9785C12.1881 11.3731 12.7482 10.8635 13.3375 11.0281C13.6925 11.1274 13.9957 11.2615 14.2503 11.4103C14.8194 11.7429 15.5339 11.3134 15.5147 10.655C15.3806 6.08789 12.7888 2.54109 11.6776 1.22542C12.3608 0.667018 13.312 0.508731 14.1636 0.853377C15.3017 1.31336 18.1697 2.72035 20.3051 5.89848C20.6328 6.38715 21.097 6.76846 21.6399 6.99482C22.1828 7.22118 22.7803 7.28257 23.3579 7.17132C27.0498 6.46151 30.9506 6.46151 34.6426 7.17132C35.2201 7.28257 35.8176 7.22118 36.3605 6.99482C36.9034 6.76846 37.3677 6.38715 37.6953 5.89848C39.8308 2.72035 42.6987 1.31336 43.8369 0.853377C44.6879 0.508957 45.6392 0.66668 46.3228 1.22542C45.2117 2.54109 42.6198 6.08789 42.4857 10.655C42.4666 11.3134 43.181 11.7429 43.7501 11.4103C44.0048 11.2615 44.3079 11.1274 44.6629 11.0281C45.2523 10.8635 45.8123 11.3731 45.7154 11.9785C45.6241 12.5501 45.5565 13.2999 45.6151 14.1217C45.6658 14.8376 46.5403 15.1657 47.0485 14.6606C47.2976 14.4126 47.5782 14.1668 47.8779 13.9583C48.4369 13.5693 49.2054 13.9752 49.202 14.6561C49.193 16.0282 49.6708 18.3258 52.3866 20.4994C53.1777 22.4757 53.6059 24.5874 53.6059 26.7802C53.6059 35.0688 50.5791 40.7824 45.2748 44.0023M6.27419 36.6607C8.82209 42.3574 13.8514 45.6968 20.6804 46.7655C21.8028 46.9414 22.8418 47.4397 23.7038 48.1782C26.3906 50.481 31.6099 50.481 34.2966 48.1782C35.1587 47.4397 36.1977 46.9414 37.3189 46.7655C38.8763 46.522 40.339 46.1613 41.7003 45.6799",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M43.4242 32.0797C43.4242 32.0797 47.6666 26.1377 57 28.6842M42.5757 36.324C42.5757 36.324 51.909 35.4752 56.1515 43.9639M14.5758 32.0797C14.5758 32.0797 10.3334 26.1377 1 28.6842M15.4242 36.324C15.4242 36.324 6.09085 35.4752 1.84844 43.9639",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M29.0001 36.3916C29.0001 37.2921 28.2708 38.022 27.3712 38.022C26.4715 38.022 25.7422 37.2921 25.7422 36.3916",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M32.2581 36.3932C32.2581 37.2942 31.5287 38.0246 30.629 38.0246C29.7293 38.0246 29 37.2942 29 36.3932V34.7852",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M22.7703 26.8404C22.7703 25.9834 22.0758 25.2886 21.2191 25.2886C20.3625 25.2886 19.668 25.9834 19.668 26.8404M35.2323 26.8404C35.2323 25.9834 35.9268 25.2886 36.7834 25.2886C37.6401 25.2886 38.3346 25.9834 38.3346 26.8404M31.6713 31.3388C31.6713 29.6879 30.4759 29.5328 29.0013 29.5328C27.5268 29.5328 26.3314 29.6879 26.3314 31.3388C26.3314 32.9896 27.5268 34.3278 29.0013 34.3278C30.4759 34.3278 31.6713 32.9896 31.6713 31.3388Z",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgCat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 51,
    viewBox: "0 0 58 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat);
export default __webpack_public_path__ + "static/media/cat.1cb407353b467e596544d14bd1d47227.svg";
export { ForwardRef as ReactComponent };